import { render, staticRenderFns } from "./Bottom_comp.vue?vue&type=template&id=7b76b547&scoped=true&"
import script from "./Bottom_comp.vue?vue&type=script&lang=js&"
export * from "./Bottom_comp.vue?vue&type=script&lang=js&"
import style0 from "./Bottom_comp.vue?vue&type=style&index=0&id=7b76b547&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b76b547",
  null
  
)

export default component.exports